<template>
  <div class="result" >
    <!-- <add-ut /> -->
    <ui-loading-circle :descText="'downloadingDot'" :applyBackground="true" v-if="!isLoaded"/>
    <result-menu :active="'status'" :utid="utid"/>
    <template v-if="isLoaded">
      <div class="bridge-content">
        <h5>전체 참여수 :</h5>
        <h3>
          {{resultData.totalTestCount | thousand}} <span>회</span>
        </h3>
        <template v-for="(item, index) in resultData.summary">
          <div v-bind:key="index">
            <h4>문항 {{index+1}}. <span>참여 <p>{{item.totalCount | thousand}}</p> 회</span></h4>
            <ul class="chard-wrap">
              <li class="chard-tit">
                <span>{{getItemTypeText(item.itemType)}} 문항</span>
                {{item.subject}}
              </li>
              <li>
                <template v-if="item.itemType === 'checkbox'">
                  <app-chart chartType="bar"
                             v-if="item.data && item.data.length > 0"
                             :width="'100%'"
                             :height="300"
                             :chartOptions="barChartOptions(item)" />
                </template>
                <template v-else>
                  <div class="chard-visual">
                    <app-chart chartType="pie"
                               v-if="item.data && item.data.length > 0"
                               :chartOptions="pieChartOption(item)"
                               :width="180"
                               :height="180" />
                  </div>
                  <div class="chard-lank">
                    <template v-for="(subItem, subIndex) in item.data">
                      <span v-if="subItem.name && subItem.count" :class="getOrderColorClassList(subIndex)" v-bind:key="index + '_' + subIndex">
                        <span>{{subIndex+1}}위</span>
                        <span>{{subItem.name}}</span>
                      </span>
                    </template>
                  </div>
                </template>
              </li>
            </ul>
            <div class="visit-table">
              <ul>
                <li>
                  <span>항목명</span>
                  <span></span>
                  <span>답변수</span>
                  <span>참여자 비율</span>
                </li>
                <template v-for="(subItem, subIndex) in item.data" >
                  <li v-if="subItem.name && subItem.count" v-bind:key="index+ '_' + subIndex">
                    <span>{{subIndex+1}}위</span>
                    <span>{{subItem.name || '-'}}</span>
                    <span>{{subItem.count | thousand}}</span>
                    <span>{{subItem.value}}%</span>
                  </li>
                </template>
                <li>
                  <span>{{getItemTypeText(item.itemType)}} 결과</span>
                  <span></span>
                  <span>{{item.checkboxTotalCount || item.totalCount | thousand}}</span>
                  <span>{{item.totalRate}}%</span>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </div>
    </template>

  </div>
</template>
<script>
import AppChart from '@/components/chart'
import ResultMenu from '@/components/result/ResultMenu'
import { getUtResult } from '@/api/ut'
import { ITEM_TYPE_TEXT, RESULT_CHART_COUNT, RESULT_CHART_ORDER_COLOR, RESULT_ORDER_COLOR_CSS } from '@/libs/constants'
import { getTooltipHtml } from '@/libs/chart-helper'

export default {
  name: 'ResultStatus',
  components: {
    AppChart,
    ResultMenu
  },
  props: [
    'utid'
  ],
  data () {
    return {
      isLoaded: false,
      resultData: null
    }
  },
  computed: {
    getItemTypeText () {
      return (type) => {
        return ITEM_TYPE_TEXT[type]
      }
    },
    getOrderColorClassList () {
      return (index) => {
        return RESULT_ORDER_COLOR_CSS[index]
      }
    }
  },
  async created () {
    await this.getData()
  },
  methods: {
    barChartOptions (item) {
      const chartData = item.data
      const xAxisData = []
      const data = []

      let maxValue = 0
      for (let i = 0, iLen = chartData.length; i < iLen; i++) {
        const subItem = chartData[i]
        if (subItem.name && subItem.count) {
          xAxisData.push(subItem.name)
          data.push({
            value: subItem.count,
            itemStyle: {
              color: RESULT_CHART_ORDER_COLOR[i] || '#0000'
            }
          })
          maxValue = Math.max(maxValue, subItem.count)
        }
      }
      //
      // const chartYAXisMaxValue = maxValue// getChartYAxisMaxValue(maxValue)
      // const chartSplitValue = getChartSplitValue(maxValue)
      //
      // console.log(chartYAXisMaxValue, chartSplitValue)

      let yAxis = {
        type: 'value',
        axisLabel: {
          formatter: '{value}'
        },
        splitNumber: 5
      }
      if (maxValue <= 5) {
        yAxis.splitNumber = 1
      }

      return {
        grid: {
          top: 20,
          right: 0,
          left: 40,
          height: 240,
          containLabel: false
        },
        legend: {
          show: false
        },
        tooltip: {
          show: true,
          formatter (params) {
            const content = [[params.marker + params.name, params.data.value]]
            return getTooltipHtml(content, (params.dataIndex + 1) + '위')
          }
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: yAxis,
        series: [{
          name: item.subject,
          barMaxWidth: 35,
          data: data,
          type: 'bar',
          emphasis: {
            itemStyle: {
              shadowColor: '#dddddd',
              shadowBlur: 0
            }
          }
        }],
        color: ['#1199af', '#9fce12', '#ffd738', '#baa7d5', '#e0e0e0']
      }
    },
    pieChartOption (item) {
      return {
        series: [
          {
            name: item.subject,
            type: 'pie',
            data: item.data,
            label: {
              show: false
            },
            tooltip: {
              show: true,
              formatter: function (params) {
                const content = [[params.marker + params.name, params.data.count]]
                return getTooltipHtml(content, (params.dataIndex + 1) + '위')
              }
            },
            radius: ['33%', '87%'],
            emphasis: {
              itemStyle: {
                shadowColor: '#dddddd',
                shadowBlur: 0
              }
            }
          }
        ],
        color: ['#1199af', '#9fce12', '#ffd738', '#baa7d5', '#e0e0e0']
      }
    },
    async getData () {
      this.isLoaded = false
      const params = {
        utid: this.utid
      }
      getUtResult(params).then(result => {
        if (result.success) {
          // this.resultData = result.result
          this.resultDataNormalize(result.result)
        }
        this.isLoaded = true
      })
    },
    resultDataNormalize (data) {
      this.resultData = {
        totalTestCount: data.totalTestCount
      }

      const summary = data.summary

      const MAX = RESULT_CHART_COUNT

      for (let i = 0, iLen = summary.length; i < iLen; i++) {
        const item = summary[i]

        const answers = item.answers
        let totalCount = item.totalCount || 0

        if (item.itemType === 'checkbox') {
          let checkboxTotalCount = 0
          for (let j = 0, jLen = answers.length; j < jLen; j++) {
            if (answers[j].key) {
              checkboxTotalCount += answers[j].count
            }
          }
          item.checkboxTotalCount = checkboxTotalCount
        }

        item.answers = item.answers.sort((a, b) => {
          if (a.count > b.count) {
            return -1
          } else if (a.count < b.count) {
            return 1
          } else {
            if (a.idx > b.idx) {
              return 1
            } else {
              return -1
            }
          }
        })

        item['data'] = []
        item.totalRate = 0

        let dataIndex = 0
        for (let j = 0, jLen = item.answers.length; j < jLen; j++) {
          const answer = item.answers[j]
          if (answer.key) {
            const count = answer.count
            answer['rate'] = (count / totalCount) * 100
            item.totalRate = item.totalRate + answer['rate']
            answer['rate'] = parseFloat(answer['rate'].toFixed(1))

            if (j < MAX) {
              item['data'].push({
                name: answer.key,
                value: answer.rate,
                count: answer.count,
                index: dataIndex++
              })
            } else {
              if (!item['data'][MAX]) {
                item['data'].push({
                  name: 'Etc',
                  value: answer.rate,
                  count: answer.count,
                  index: dataIndex++
                })
              } else {
                let etcCount = item['data'][MAX].count || 0
                let etcRate = item['data'][MAX].value || 0
                item['data'][MAX]['count'] = etcCount + count
                item['data'][MAX]['value'] = etcRate + answer['rate']
              }
            }
          }
        }

        item.totalRate = parseFloat(item.totalRate.toFixed(1))
      }
      this.resultData['summary'] = data.summary
    }
  }
}
</script>

<style lang="scss" scoped>
.result {
  margin: 90px auto 0;
  padding-bottom: 160px;
  & > p {
    font-size: 13px;
    color: #1990c2;
    text-align: center;
    margin-top: 30px;
  }
  & > h1 {
    width: 990px;
    font-size: 20px;
    font-weight: 500;
    color: #2f2f2f;
    margin: 0 auto;
    & span {
      display: inline-block;
      width: 32px;
      height: 32px;
      vertical-align: top;
      border-radius: 5px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
      background: #fff url('../../../assets/images/icon-page-back.svg') no-repeat center;
      margin-right: 30px;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        background: #f7f7f7 url('../../../assets/images/icon-page-back.svg') no-repeat center;
      }
    }
    & > button {
      display: inline-block;
      margin: 0px 40px 0 0;
      padding-bottom: 8px;
      color: #999;
      vertical-align: top;
      cursor: default;

      &.active {
        border-bottom: 3px solid #ec0047;
        color: #2f2f2f;
        cursor: pointer;
      }
    }
  }
  .bridge-content {
    width: 990px;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.10), 0 0 0 1px rgba(0, 0, 0, 0.10);
    background: #fff;
    padding: 60px;
    box-sizing: border-box;
    margin: 30px auto 0;
    & > div {
      margin-bottom: 140px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    h3 {
      font-size: 50px;
      font-weight: 500;
      color: #2f2f2f;
      display: block;
      line-height: 1.1;
      padding-bottom: 20px;
      margin-bottom: 70px;
      border-bottom: 1px solid #d7d7d7;
      span {
        font-size: 16px;
        font-weight: 500;
        color: #444;
        line-height: 1;
      }
    }
    h5 {
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: 500;
      color: #444;
      line-height: 1;
    }
    h4 {
      font-size: 24px;
      color: #1990c2;
      font-weight: bold;
      margin-bottom: 40px;
      span {
        font-size: 15px;
        font-weight: 500;
        color: #444;
        display: inline-block;
        margin-left: 20px;
        p {
          display: inline-block;
          font-size: 20px;
          font-weight: 500;
          color: #444;
        }
      }
    }
    .chard-wrap {
      & > li {
        &.chard-tit {
          font-size: 24px;
          font-weight: 500;
          line-height: 1.29;
          margin-bottom: 30px;
          span {
            display: block;
            font-size: 12px;
            font-weight: 500;
            line-height: 1;
            color: #767676;
            margin-bottom: 6px;
          }
        }
        .chard-visual {
          width: 180px;
          height: 180px;

          float: left;
        }
        .chard-lank {
          float: left;
          width: calc(100% - 250px);
          margin: 25px 0 0 50px;
          & > span {
            position: relative;
            width: 100%;
            display: inline-block;
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 20px;
            color: #222;
            & > span {
              width: 30px;
              display: inline-block;
              vertical-align: middle;
              overflow: hidden;
              &:last-child {
                font-weight: normal;
                color: #666;
                margin-left: 5px;
                width: calc(100% - 35px);
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            &::after {
              content: "";
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: -17px;
              width: 8px;
              height: 8px;
              border-radius: 50%;
            }
            &.blue {
              &::after {
                background: #1199af;
              }
            }
            &.green {
              &::after {
                background: #9fce12;
              }
            }
            &.orange {
              &::after {
                background: #deaf00;
              }
            }
            &.purple {
              &::after {
                background: #baa7d5;
              }
            }
          }
        }
        .stick-wrap {
          width: 100%;
          height: 300px;
          background: #555;
        }
      }
    }

    .visit-table {
      clear: both;
      overflow: hidden;
      ul {
        margin-top: 30px;
        border: 1px solid #ebebeb;
        border-radius: 10px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        li {
          height: auto;
          min-height: 65px;
          box-sizing: border-box;
          padding: 20px 0;
          font-size: 14px;
          line-height: 1.57;
          color: #444;
          border-bottom: 1px solid #ebebeb;
          &:first-child {
            height: 50px;
            min-height: 50px;
            padding-top: 20px;
            box-sizing: border-box;
            font-size: 13px;
            font-weight: 500;
            color: #fff;
            background: #333;
            border-top-right-radius: 6px;
            border-top-left-radius: 6px;
            span {
              &:nth-child(1) {
                color: #fff;
              }
            }
          }
          span {
            display: inline-block;
            vertical-align: middle;
            box-sizing: border-box;
            &:nth-child(1) {
              width: 10%;
              text-align: left;
              padding-left: 20px;
              font-size: 14px;
              font-weight: 500;
              color: #222;
            }
            &:nth-child(2) {
              width: 65%;
            }
            &:nth-child(3) {
              width: 15%;
              text-align: center;
            }
            &:nth-child(4) {
              width: 10%;
              text-align: right;
              padding-right: 20px;
            }
          }
          &:last-child {
            background: #eee;
            border-top: 1px solid #c1c1c1;
            border-bottom: 1px solid #c1c1c1;
            margin-top: -1px;
            span {
              &:nth-child(1) {
                width: 30%;
                text-align: left;
                padding-left: 20px;
              }
              &:nth-child(2) {
                width: 45%;
              }
              &:nth-child(3) {
                font-weight: 500;
              }
              &:nth-child(4) {
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }
}

@media all and (max-width: 990px) {
  .result {
      min-width: 768px;
      & > h1 {
          width: calc(100% - 40px);
      }
      .bridge-content {
        position: relative;
        width: calc(100% - 40px);
        height: auto;
        .visit-table {
          ul {
            li {
              span {
                &:nth-child(1) {
                  width: 10%;
                }
                &:nth-child(2) {
                  width: 60%;
                }
                &:nth-child(3) {
                  width: 15%;
                }
                &:nth-child(4) {
                  width: 15%;
                }
              }
              &:last-child {
                span {
                  &:nth-child(1) {
                    width: 25%;
                    text-align: left;
                    padding-left: 20px;
                  }
                  &:nth-child(2) {
                    width: 45%;
                  }
                  &:nth-child(3) {
                  }
                  &:nth-child(4) {
                  }
                }
              }

            }
          }
        }
      }
  }
}

</style>
